import { render } from "./PolicyGroupsManager.vue?vue&type=template&id=15704c22&scoped=true"
import script from "./PolicyGroupsManager.vue?vue&type=script&lang=js"
export * from "./PolicyGroupsManager.vue?vue&type=script&lang=js"

import "./PolicyGroupsManager.vue?vue&type=style&index=0&id=15704c22&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15704c22"]])

export default __exports__